import { Action } from '@ngrx/store';
import { Merchant } from '../models/merchant.model';

export enum MerchantActions {
    CreateMerchant = '[Merchant] Create Merchant',
    SuccessCreateMerchant = '[Merchant] Success Create Merchant',
    FailCreateMerchant = '[Merchant] Fail Create Merchant',
    
    GetMerchant = '[Merchant] Get Merchant',
    SuccessGetMerchant = '[Merchant] Success Get Merchant',
    FailGetMerchant = '[Merchant] Fail Get Merchant',
    
    DeleteMerchant = '[Merchant] Delete Merchant',
    SuccessDeleteMerchant = '[Merchant] Success Delete Merchant',
    FailDeleteMerchant = '[Merchant] Fail Delete Merchant',
    
    UpdateMerchant = '[Merchant] Update Merchant',
    SuccessUpdateMerchant = '[Merchant] Success Update Merchant',
    FailUpdateMerchant = '[Merchant] Fail Update Merchant',
}

export class CreateMerchant implements Action {
    readonly type = MerchantActions.CreateMerchant;
    constructor(public payload: Merchant) {}
}

export class SuccessCreateMerchant implements Action {
    readonly type = MerchantActions.SuccessCreateMerchant;
    constructor(public payload: Merchant) {}
}

export class FailCreateMerchant implements Action {
    readonly type = MerchantActions.FailCreateMerchant;
    constructor(public payload: any) {}
}

export class GetMerchant implements Action {
    readonly type = MerchantActions.GetMerchant;
    constructor(public payload: string) {} 
}

export class SuccessGetMerchant implements Action {
    readonly type = MerchantActions.SuccessGetMerchant;
    constructor(public payload: Merchant) {}
}

export class FailGetMerchant implements Action {
    readonly type = MerchantActions.FailGetMerchant;
    constructor(public payload: any) {}
}

export class DeleteMerchant implements Action {
    readonly type = MerchantActions.DeleteMerchant;
    constructor(public payload: string) {} 
}

export class SuccessDeleteMerchant implements Action {
    readonly type = MerchantActions.SuccessDeleteMerchant;
    constructor(public payload: string) {}
}

export class FailDeleteMerchant implements Action {
    readonly type = MerchantActions.FailDeleteMerchant;
    constructor(public payload: any) {}
}

export class UpdateMerchant implements Action {
    readonly type = MerchantActions.UpdateMerchant;
    constructor(public payload: Merchant) {}
}

export class SuccessUpdateMerchant implements Action {
    readonly type = MerchantActions.SuccessUpdateMerchant;
    constructor(public payload: Merchant) {}
}

export class FailUpdateMerchant implements Action {
    readonly type = MerchantActions.FailUpdateMerchant;
    constructor(public payload: any) {}
}

export type MerchantAction = 
    | CreateMerchant 
    | SuccessCreateMerchant 
    | FailCreateMerchant 
    | GetMerchant 
    | SuccessGetMerchant 
    | FailGetMerchant 
    | DeleteMerchant 
    | SuccessDeleteMerchant 
    | FailDeleteMerchant 
    | UpdateMerchant 
    | SuccessUpdateMerchant 
    | FailUpdateMerchant;
